/*!
 * @license MPL-2.0
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * Contributors:
 *   - See Git history at https://github.com/FilteringDev/tinyShield for detailed authorship information.
 */

export function CountCommonStrings(ArrayA: string[], ArrayB: string[]): number {
  let SetB = new Set(ArrayB)
  const Common = new Set(ArrayA.filter(Item => SetB.has(Item)))
  return Common.size
}